import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@components/Modal/Modal';
import { LoadingBackdrop } from '@components/LoadingBackdrop/LoadingBackdrop';
import { Form, Row } from '@components/form/Form/Form';
import * as TextField from '@components/form/TextField/TextField';

type SaveRouteAsSelectionSetModalProps = {
    setModalShow: (visible: boolean) => void;
    name: string;
    onNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
    saving: boolean;
    canSave: boolean;
};

const SaveRouteAsSelectionSetModal = memo(
    ({
        setModalShow,
        name,
        onNameChange,
        onSubmit,
        saving,
        canSave,
    }: SaveRouteAsSelectionSetModalProps) => {
        const { t } = useTranslation();

        return (
            <Modal
                title={t('road-network.save-route-as-selection-set.modal-title')}
                setVisible={setModalShow}
                narrow={true}
            >
                <LoadingBackdrop isVisible={saving} transparent>
                    <Form
                        name="save-route-as-selection-set-form"
                        onSubmit={onSubmit}
                        submitBtnTitle={t('road-network.save-route-as-selection-set.submit-btn')}
                        disabled={!canSave}
                    >
                        <Row>
                            <TextField.Labeled
                                name="name"
                                type="text"
                                label={t(
                                    'road-network.save-route-as-selection-set.selection-set-name'
                                )}
                                value={name}
                                onChange={onNameChange}
                                required
                                autoFocus
                            />
                        </Row>
                    </Form>
                </LoadingBackdrop>
            </Modal>
        );
    }
);

export default SaveRouteAsSelectionSetModal;
